import { ImportsScreen } from '@/features/imports/imports-screen';

export function ImportsPage() {
  return <ImportsScreen />;
}
